import React, { useEffect, useState } from "react";
import "./LoadingColserauto.scss"; // Importa el archivo CSS

const LoadingColserauto = ({ isDone }) => {
    const [isFadingOut, setIsFadingOut] = useState(false);

    useEffect(() => {
        // Cuando el padre nos dice que ya ha terminado la carga (isDone cambia a true)
        if (isDone) {
            setIsFadingOut(true); // Activa la clase para el desvanecimiento
        }
    }, [isDone]);
    return (
        <div className={`loading-overlay ${isFadingOut ? "fade-out" : ""}`}>
            <img
                src="/assets/icons/featureList/colserauto-pdf.png"
                alt="Logo de la Marca"
                className="logo-zoom-animation"
            />
        </div>
    );
};

export default LoadingColserauto;
